module.exports = __webpack_public_path__ + "static/ame-6708b94a772f90e02c4dc7f7586524e8.png";